import * as tslib_1 from "tslib";
/** @jsx jsx */

import { jsx } from "@emotion/core";
import PropTypes from "prop-types";
import { useTheme } from "./Theme/Providers";
/**
 * A styled anchor element
 */

export var Link = function Link(_a) {
  var children = _a.children,
      _b = _a.component,
      Component = _b === void 0 ? "a" : _b,
      other = tslib_1.__rest(_a, ["children", "component"]);

  var theme = useTheme();
  return jsx(Component, tslib_1.__assign({
    className: "Link",
    css: {
      textDecoration: "none",
      "@media (hover:hover)": {
        ":hover": {
          textDecoration: "underline"
        }
      },
      color: theme.colors.mode === "dark" ? theme.colors.palette.blue.light : theme.colors.palette.blue.base
    }
  }, other), children);
};
Link.propTypes = {
  component: PropTypes.any,
  children: PropTypes.node
};